module.exports = __webpack_public_path__ + "static/img/edge.169cd4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010106/edge.png
// module id = DZ6l
// module chunks = 10